import { makeStyles, Theme } from '@material-ui/core';
import { isDarkTheme } from '../../eliot-components/src/theme';

export const useSensorTableStyles = makeStyles((theme: Theme) => ({
  summary: {
    height: '48px',
    borderTop: '1px',
    borderColor: theme.palette.text.primary,
    backgroundColor: isDarkTheme(theme)
      ? theme.palette.secondary.main
      : '#eeeeee',
    [theme.breakpoints.down('sm')]: {
      marginBottom: theme.spacing(1),
    },
  },
  summaryItem: {
    padding: '0 15px',
  },
  table: {
    '& thead': {
      backgroundColor: isDarkTheme(theme) ? '#393939' : '#eeeeee',
      borderBottom: '2px solid rgba(0,0,0,0.12)',
    },

    '& > tbody > tr:nth-of-type(even)': {
      backgroundColor: isDarkTheme(theme) ? '#393939' : '#fafafa',
    },

    '& td': {
      paddingTop: 0,
      paddingBottom: 0,
    },
  },
  title: {
    marginBottom: theme.spacing(2),
  },
}));
